import { combineReducers } from 'redux';
import { handleActions, combineActions } from 'redux-actions';
import * as types from './draft-constants';

export const isDeletingDraft = handleActions(
  {
    [types.DELETE_DRAFT_REQUEST]: () => true,
    [combineActions(
      'LOCATION_CHANGE',
      types.DELETE_DRAFT_FAILURE,
    )]: () => false,
  },
  false,
);

export default combineReducers({
  isDeletingDraft,
});
